import { createReducer } from "redux-act";
import * as actions from "modules/actions";

export interface IState {
	id: string
	name: string
}

export interface IStatesReducerState {
	items: Record<string, IState>,
	is_fetched: boolean,
}

const initialState: IStatesReducerState = {
	items: {},
	is_fetched: false,
};

export const states = createReducer<IStatesReducerState>( {}, initialState );

states.on( actions.fetchStatesJSONSuccess, ( state, payload ) => ({
	...state,
	items: payload,
	is_fetched: true,
}) );

states.on( actions.fetchStatesJSONFailed, () => (initialState) );
